import { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

import { GateAppBar } from 'components/navigation';
import { DamageProvider, NewTransactionProvider, TireInspectionsProvider } from 'pages/new-transaction';
import { GateEditBooking, GateNewBooking, GateNewBookingProvider } from 'pages/new-transaction/booking';
import './gate-application.scss';

const backgroundImage = require('assets/images/login-banner.jpeg');

const GateWrapper: FC<PropsWithChildren> = ({ children }) => (
  <GateNewBookingProvider>
    <TireInspectionsProvider>
      <DamageProvider>
        <NewTransactionProvider>
          <img alt="background" id="gate-app-background" width="100%" height="100%" src={backgroundImage} />
          <div id="gate-app-container" className="d-flex flex-column align-items-center h-100">
            <GateAppBar />
            <div id="gate-app-content" className="flex-fill w-100">
              <Outlet />
              {children}
            </div>
            {/* forms cannot be nested -- use gateNewBooking context to pass props from transaction to booking */}
            <GateNewBooking />
            <GateEditBooking />
          </div>
        </NewTransactionProvider>
      </DamageProvider>
    </TireInspectionsProvider>
  </GateNewBookingProvider>
);

export default GateWrapper;
